import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { get } from 'axios'; // Not using helpers/api since we need page_options.options to be snake_cased
import { put } from 'helpers/api';
import Option from '../document_defaults/option_defaults/option';
import Button from 'shared/button';
import { showSnackbar } from 'components/ui/snackbar/helper';

export default function InvoiceDefaults({ pageOptionsPath }) {
  const [options, setOptions] = useState([]);
  const [pageOption, setPageOption] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    async function fetchData() {
      const pageOptionsData = await get(pageOptionsPath);
      setOptions(pageOptionsData.data.all_options);
      setPageOption(pageOptionsData.data.page_options);
    }

    fetchData();
  }, []);

  function updateOption(changes) {
    setPageOption({ ...pageOption, options: { ...pageOption.options, ...changes } });
  }

  function handleRemoveOptions(names) {
    const updatedOptions = Object.keys(pageOption.options).reduce((accumulator, key) => {
      if (!names.includes(key)) accumulator[key] = pageOption.options[key];
      return accumulator;
    }, {});

    setPageOption({ ...pageOption, options: updatedOptions });
  }

  async function saveDefaults() {
    setSaving(true);

    await put(pageOptionsPath, {
      unscope: false,
      pageDefaults: {
        pageName: pageOption.pageName,
        pageTemplateUserLabel: pageOption.pageTemplateUserLabel,
        options: pageOption.options,
        pageTemplateStyleId: pageOption.pageTemplateStyleId
      }
    });

    setSaving(false);
    showSnackbar({ text: 'Changes successfully saved', variant: 'success' });
  }

  return (
    <React.Fragment>
      <div className="form-horizontal">
        <div className="mb-4 d-flex justify-content-between align-items-center">
          <h5>Invoice Defaults</h5>
          <Button.Primary disabled={saving} onClick={saveDefaults}>Save Defaults</Button.Primary>
        </div>
        {options.map((option, i) => (
          <div className={i < options.length - 1 ? 'mb-3' : ''} key={option.name}>
            <Option
              defaults={pageOption.options || {}}
              option={option}
              onRemove={handleRemoveOptions}
              onUpdate={updateOption}
            />
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}

InvoiceDefaults.propTypes = {
  pageOptionsPath: PropTypes.string.isRequired
};
